import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import LeadForm from '../components/LeadForm.jsx';
import ChainEntryForm from '../components/ChainEntryForm.jsx';

export default function LeadNew() {
  const navigate = useNavigate();
  const [chainMode, setChainMode] = useState(false);

  async function handleSubmit(form) {
    await axios.post('/api/leads', form);
    navigate('/leads');
  }

  return (
    <section className="page">
      <div className="page-header">
        <h2>Add New Lead</h2>
        <Link to="/leads" className="btn-secondary">← Back to Sales Leads</Link>
      </div>

      <div className="chain-toggle">
        <span className="chain-toggle-label">Part of existing chain?</span>
        <div className="chain-toggle-segmented">
          <button
            type="button"
            className={`chain-toggle-option${!chainMode ? ' chain-toggle-active' : ''}`}
            onClick={() => setChainMode(false)}
          >
            No · New company
          </button>
          <button
            type="button"
            className={`chain-toggle-option${chainMode ? ' chain-toggle-active' : ''}`}
            onClick={() => setChainMode(true)}
          >
            Yes · Pick existing chain
          </button>
        </div>
      </div>

      {chainMode ? (
        <ChainEntryForm
          recordType="lead"
          onSubmit={handleSubmit}
          submitLabel="Create Lead"
          onCancel={() => navigate('/leads')}
        />
      ) : (
        <LeadForm
          compact
          onSubmit={handleSubmit}
          submitLabel="Create Lead"
          onCancel={() => navigate('/leads')}
        />
      )}
    </section>
  );
}
